import { createSlice } from '@reduxjs/toolkit'

export const popupSlice = createSlice({
	name: 'popup',
	initialState: {
		isVisible: false,
		error: null,
		isEmailPopup: false,
	},
	reducers: {
		showPopup: (state, { payload }) => {
			state.isVisible = true
			state.error = payload
		},
		hidePopup: (state) => {
			state.isVisible = false
			state.error = null
			state.isEmailPopup = false
		},
		getEmailSuccess: (state) => {
			state.isVisible = true
			state.isEmailPopup = true
		},
	},
})

export const { showPopup, hidePopup, getEmailSuccess } = popupSlice.actions
export const { reducer } = popupSlice
